import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-indicator',
  templateUrl: './progress-indicator.component.html',
  styleUrls: ['./progress-indicator.component.scss'],
  standalone: false,
})
export class ProgressIndicatorComponent {
  @Input() value: number;

  @Input() color: 'PRIMARY' | 'SECONDARY' = 'PRIMARY';

  getProgressIndicatorClass() {
    const classes = ['progress-indicator'];

    if (this.color === 'SECONDARY') {
      classes.push('progress-indicator-secondary');
    }

    return classes.join(' ');
  }

  getProgressIndicatorBarClassFor(minPercentage: number) {
    const classes = ['progress-indicator-bar'];

    if (Math.round(this.value) >= minPercentage) {
      classes.push('progress-indicator-bar-on');
    }

    return classes.join(' ');
  }
}
